import {Component, OnInit} from '@angular/core';
import {AppContainerOptions, AppContainerService, IAppContainerFrame, UserMenuItemsEnum, SwUpdateService} from '@mydocma/app-container';
import {environment} from '../../environments/environment';
import package_json from '../../../package.json';
import { ConfigProvider } from '@mydocma/common';

const MIN_RIGHT_PANE_WIDTH_PX = 422;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [],
})
export class MainComponent implements OnInit, IAppContainerFrame {

  public version: string = package_json.version;

  constructor(
    public options: AppContainerOptions,
    private appContainerService: AppContainerService,
    private readonly swUpdateService: SwUpdateService,
  ) {
    const configProvider =  ConfigProvider.instance;
    this.appContainerService.notifyChanges((appcontainer) => {
      appcontainer.appIcon.name = configProvider.getConfigData()?.appName;
      appcontainer.appIcon.color = configProvider.getConfigData()?.appIconColor;
      appcontainer.header.userMenuItems.version = this.version;
      appcontainer.header.userMenuItems.items.find(value => {
        if (value.id === UserMenuItemsEnum.userSettings) {
          value.hidden = true;
          return;
        }
      });
      // TODO: prevent pane from collapsing bellow minimum width (manually) >
      // TODO: it is not behaving as expected, sometimes collapses bellow width is allowed, investigate further.
      // TODO: WIP: to be removed when the issue is fixed
      // appcontainer.splitter = appcontainer.splitter || {} as any;
      // appcontainer.splitter.right = appcontainer.splitter.right || {} as any;
      // appcontainer.splitter.right.panelOptions = {
      //   // ...(appcontainer.splitter.right.panelOptions || {}),
      //   minWidth: MIN_RIGHT_PANE_WIDTH_PX
      // } as any;
    });
  }

  acOnRegister(appContainer: AppContainerOptions) {
    // buttons.push(new LinkSideNavButton({id: 'pix3', text: 'Help', url: '/pix/help'}));
    // appContainer.sideNavBar.buttons = buttons;
  }

  acOnUnregister(appContainer: AppContainerOptions) {
    appContainer.sideNavBar.buttons = [];
    appContainer.topActionsBar.buttons = [];
  }

  ngOnInit() {
  }

}
